import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import type { PropsWithChildren } from 'react'
import { useState } from 'react'
import { I18nextProvider } from 'react-i18next'

import { FeedbackProvider } from '@/components/feedback/feedback-provider'
import { BrandingProvider } from '@/features/shared/brand/branding-provider'
import i18n from '@/i18n/i18n'

export function AppProviders({ children }: PropsWithChildren) {
  const [queryClient] = useState(
    () =>
      // 每次应用挂载只创建一个 QueryClient；渲染时重建会清空缓存和 mutation 状态。
      new QueryClient({
        defaultOptions: {
          queries: {
            retry: 1,
            staleTime: 30_000,
            refetchOnWindowFocus: false,
          },
          mutations: {
            retry: 0,
          },
        },
      }),
  )

  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <BrandingProvider>
          <FeedbackProvider>{children}</FeedbackProvider>
        </BrandingProvider>
      </QueryClientProvider>
    </I18nextProvider>
  )
}
